import { CoreRegenerateLeagueTableView } from '../../../../../core/views';
import './index.styl';

/**
 * @desc Regenerate League Table View Class
 * This class using on leagues my page ('fantasy/regeneration')
 */
export default class RegenerateLeagueTableView extends CoreRegenerateLeagueTableView {
	get className() {
		return "my-leagues-table regenerate-table";
	}
}